const initialState = {
    user: {}
}

export const userReducer = ((state = initialState, {type, payload}) => {
    switch(type){
        default:
            return state;
    }
})